import { render, staticRenderFns } from "./DialogTabsContainer.vue?vue&type=template&id=e257201e"
import script from "./DialogTabsContainer.vue?vue&type=script&lang=js"
export * from "./DialogTabsContainer.vue?vue&type=script&lang=js"
import style0 from "./DialogTabsContainer.vue?vue&type=style&index=0&id=e257201e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports